import React from 'react';
import { FadeIn } from './ui/FadeIn';
const steps = [{
  number: '01',
  title: 'Descarga tu diario',
  description: 'Recibe acceso inmediato al material digital. Puedes leerlo en tu tablet, computadora o imprimirlo en casa.'
}, {
  number: '02',
  title: 'Sigue el plan semanal',
  description: 'Cada semana introduce un pequeño cambio. Sin prisa, a tu propio ritmo, siguiendo las guías claras.'
}, {
  number: '03',
  title: 'Duerme mejor',
  description: 'Al finalizar las 6 semanas, habrás construido hábitos sólidos que te permitirán descansar profundamente.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-cream-50" data-id="element-83">
      <div className="container mx-auto px-6" data-id="element-84">
        <FadeIn data-id="element-85">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-86">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-87">
              Así de simple funciona
            </h2>
            <p className="text-xl text-navy-700" data-id="element-88">
              Sin complicaciones tecnológicas. Diseñado para ser fácil de usar
              desde el primer día.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-89">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-cream-200 -z-0 transform -translate-y-1/2" data-id="element-90" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-91">
              <div className="flex flex-col items-center text-center" data-id="element-92">
                <div className="w-24 h-24 bg-white rounded-full border-4 border-gold-500 flex items-center justify-center text-3xl font-bold text-navy-900 font-serif mb-8 shadow-lg" data-id="element-93">
                  {step.number}
                </div>
                <h3 className="text-2xl font-bold text-navy-900 mb-4 font-serif" data-id="element-94">
                  {step.title}
                </h3>
                <p className="text-lg text-navy-700 leading-relaxed max-w-xs" data-id="element-95">
                  {step.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}